import api from "./api";

const MIGRATION_TIMEOUT_MS = 120000;

export const getMigrationTenants = async () => {
  try {
    const response = await api.get('/master/migrations/tenants', {
      timeout: MIGRATION_TIMEOUT_MS,
    });
    return response.data;
  } catch (error) {
    console.error("There was an error fetching the tenants:", error);
    throw error;
  }
};

export const runTenantMigration = async (tenantKey) => {
  try {
    const response = await api.post(
      `/master/migrations/run/${encodeURIComponent(tenantKey)}`,
      null,
      { timeout: MIGRATION_TIMEOUT_MS }
    );
    return response.data;
  } catch (error) {
    logApiError("runTenantMigration", error);
    throw error;
  }
};

export const rollbackTenantMigration = async (tenantKey) => {
  try {
    const response = await api.post(
      `/master/migrations/rollback/${encodeURIComponent(tenantKey)}`,
      null,
      { timeout: MIGRATION_TIMEOUT_MS }
    );
    return response.data;
  } catch (error) {
    logApiError("rollbackTenantMigration", error);
    throw error;
  }
};

export const baselineTenantMigrations = async (tenantKey) => {
  try {
    const response = await api.post(
      `/master/migrations/baseline/${encodeURIComponent(tenantKey)}`,
      null,
      { timeout: MIGRATION_TIMEOUT_MS }
    );
    return response.data;
  } catch (error) {
    logApiError("baselineTenantMigrations", error);
    throw error;
  }
};

export const getTenantMigrationStatus = async (tenantKey) => {
  try {
    const response = await api.get(
      `/master/migrations/status/${encodeURIComponent(tenantKey)}`,
      { timeout: MIGRATION_TIMEOUT_MS }
    );
    return response.data;
  } catch (error) {
    logApiError("getTenantMigrationStatus", error);
    throw error;
  }
};

export const extractApiError = (err) => {
  const data = err?.response?.data;
  return {
    message: data?.message || err?.message || "Unknown error",
    code: data?.code || "UNKNOWN",
    requestId: data?.requestId,
  };
};

const logApiError = (label, err) => {
  const data = err?.response?.data;
  if (data?.requestId) {
    console.error(`[${label}] requestId=${data.requestId}`, data);
  } else {
    console.error(`[${label}]`, err);
  }
};
